export const KANZY_ID = 8;
export const isKanzyChar = (char) => Number(char?.users_ID) === KANZY_ID;
export const ANIMAL_RACE = "Animal";
export const isAnimalChar = (char) => char?.Race_character === ANIMAL_RACE;
export const isMobChar   = (char) =>
  isAnimalChar(char) || char?.Name_character?.slice(0, 3).toUpperCase() === "MOB";

// ── Exemplaires multiples d'un animal en session MJ ──
// Encodage URL : "12x3" = personnage 12 en 3 exemplaires
export const parseSessionToken = (token) => {
  const [id, count] = String(token).split("x");
  return { id, count: Math.max(1, Number(count) || 1) };
};

// Démultiplie un animal en N exemplaires (mêmes stats de base, jauges indépendantes)
export const expandAnimalInstances = (char, count) => {
  if (!isAnimalChar(char)) return [char];
  return Array.from({ length: count }, (_, i) => ({
    ...char,
    ID_character: `${char.ID_character}-${i + 1}`,
    Name_character: count > 1 ? `${char.Name_character} #${i + 1}` : char.Name_character,
    _baseId: char.ID_character,
    _isInstance: true,
  }));
};

export const GAUGE_FIELDS = [
  { key: "currentStamina",     label: "Stamina",       maxKey: "Stamina_character",      color: "#4caf50" },
  { key: "currentManaVital",   label: "Mana Vital",    maxKey: "ManaVital_character",    color: "#f87171" },
  { key: "currentManaAir",     label: "Mana Air",      maxKey: "ManaAir_character",      color: "#14b8a6" },
  { key: "currentManaEau",     label: "Mana Eau",      maxKey: "ManaEau_character",      color: "#60a5fa" },
  { key: "currentManaTerre",   label: "Mana Terre",    maxKey: "ManaTerre_character",    color: "#fb923c" },
  { key: "currentManaFeu",     label: "Mana Feu",      maxKey: "ManaFeu_character",      color: "#fb7185" },
  { key: "currentManaVolonte", label: "Mana Volonté",  maxKey: "ManaVolonte_character",  color: "#a855f7" },
];

export const CARAC_FIELDS = [
  { key: "Force_character",      label: "Force" },
  { key: "Dexte_character",      label: "Dextérité" },
  { key: "Resistance_character", label: "Résistance" },
  { key: "Resilience_character", label: "Résilience" },
  { key: "Intell_character",     label: "Intelligence" },
  { key: "Charisme_character",   label: "Charisme" },
  { key: "Chance_character",     label: "Chance" },
];
